import styled, {css} from "styled-components";
import {Colors, FlexBox, RectangularButtonFilled, RectangularButtonHollow} from "@brg/ui";
import { LayoutConst } from "core";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.folders.editModal.mainbg};
  width: 564px;
  padding: 24px 24px 24px 0px;
  row-gap: 24px;

  @media(max-width: ${LayoutConst.screen.m}px) {
    width: 348px;
    padding: 16px 0 0 0;
  }

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    width: 100%;
    row-gap: 16px;
  }

  .__react_component_tooltip {
    width: max-content !important;
  }

  input {
    background-color: ${({ theme }) => theme.folders.editModal.inputColor};
    color: ${({ theme }) => theme.folders.editModal.inputColor2};
    border-color: transparent;

    ::placeholder {
        color: #BFBFBF;
    }

    &:hover {
        ::placeholder {
            color: #BFBFBF;
        }
    }
  }

  span {
    color: #151514;
    font-size: 13px;
    line-height: 17px;
    margin-left: 10px;
  }

  input[type=checkbox] {
    background-color: transparent;
    border-color: #909090;
    width: 24px;
    height: 24px;
  }

  div[title=''] {
    width: 24px;
    height: 24px;
    border-color: #909090 !important;
    background-color: transparent;

    svg path {
      fill: ${({ theme }) => theme.folders.editModal.iconColor};
    }
  }

  .checkbox-text {
    font-size: 15px;
    line-height: 20px;
    color: #909090;
    position: absolute;
    left: 20px;
    bottom: 0;

    @media(max-width: ${LayoutConst.screen.md}px) {
      display: inline-flex;

      div {
        margin-left: 8px;
      }
    }
  }
`;

export const PinCheckboxWrapper = styled(FlexBox)<{ disable?: boolean }>`
  ${({ disable }) => disable && css`
    pointer-events: none;

    div[title=''] {
      opacity: 0.1;
    }

    input {
      opacity: 0.1;
    }
  `};
`;

export const Subtitle = styled.div`
    color: ${({ theme }) => theme.folders.editModal.subtitleColor};
    font-size: 15px;
    line-height: 20px;
    font-weight: 400;
`;

export const CloseModalIconWrapper = styled.div`
    position: absolute;
    right: 0;

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    right: 10px;
  }

  &:hover {
    svg path {
      fill: #151514;
    }
  }
`

export const Title = styled.div`
  color: ${({ theme }) => theme.folders.editModal.titleColor};
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 17px
  line-height: 22px;
  letter-spacing: -0.02em;

`

export const SendButton = styled.div<{isDisabled?: boolean, hollow?: boolean, fill?: boolean, red?: boolean, fullWidth?: boolean }>`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: -0.02em;
  height: 40px;
  color: ${({ theme, fill }) => fill ? theme.folders.editModal.buttonColorFill : theme.folders.editModal.buttonColorHollow};
  column-gap: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 121px;
  padding: 10px 24px;
  max-width: 348px;
  text-align: center;
  white-space: nowrap;
  background-color: ${({ hollow }) => hollow ? 'transparent' : '#151514'};
  opacity: ${({isDisabled}) => isDisabled ? 0.5 : 1};
  cursor: ${({isDisabled}) => isDisabled ? 'auto' : 'pointer'};
  border-radius: 3px;

  ${({ hollow, theme, red }) => hollow && css`
    border: 1px solid ${red ? '#C64839' : '#B6B6B5'};
    color: ${red ? '#C64839' : theme.folders.editModal.buttonColorHollow};
  `};

  @media(max-width: ${LayoutConst.screen.m}px) {
    font-size: 15px;
    line-height: 20px;
    min-width: ${({ fullWidth }) => fullWidth ? '348px' : '166px' };
    text-align: center;
    justify-content: center;

    ${({ red }) => red && css`
      margin-bottom: 8px;
    `};
  }
  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    width: 100%;
    min-width: 100%;
    height: 32px !important;
  }

  &:hover {
    .send-word {
      color: #151514;
    }

    svg path {
      fill: #151514;
    }
  }
`

export const ShareModalUrlField = styled.div`
  display: flex;
  align-items: center;
  padding: 15px 16px 13px;
  background: #F2F2F2;
  border-radius: 3px;
  height: 44px;
  width: 341px;

  span {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    color: #909090;
    width: 90%;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`

export const ShareModalUrlButton = styled(RectangularButtonFilled)<{isGameDeziiign?: boolean}>`
  height: 44px !important;
  width: 151px !important;
  min-width: 151px !important;
  max-width: 151px !important;
  ${({isGameDeziiign}) => isGameDeziiign && css`
    color: ${Colors.geoWhite100};
    background: ${Colors.galBlack100};
  `}
  
  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    width: calc(100% - 20px) !important;
    min-width: calc(100% - 20px) !important;
    max-width: calc(100% - 20px) !important;
    height: 38px !important;
    margin: 0px 10px;
    
    span {
      margin-left: 8px;
    }
  }
  
  svg {
    path {
      fill: ${({theme}) => theme.navigationBar.btns.filled.text.main};
      stroke: ${({theme}) => theme.navigationBar.btns.filled.text.main};

      ${p => p.importantStyles ? css`
        fill: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.main};
        stroke: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.main};
    ` : null}

      &:hover {
        ${p => p.importantStyles ? css`
          fill: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.text};
          stroke: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.text};
    ` : null}
      }
      
      &:active {
        ${p => p.importantStyles ? css`
          fill: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.text};
          stroke: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.text};
    ` : null}
    }
    &:disabled {
        fill: ${({theme}) => theme.navigationBar.btns.filled.text.disabled};

        ${p => p.importantStyles ? css`
          fill: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.text};
          stroke: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.text};
    ` : null}
    }
    }
  }
`

export const SubmitModalShareButton = styled(RectangularButtonFilled)`
  min-width: unset!important;
  max-width: unset!important;
  width: auto!important;
  padding: 12px 48px;
  font-weight: 600;
  font-size: 17px;
  line-height: 22px;
  height: 46px!important;
  letter-spacing: -0.02em;
  
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: 13px;
    line-height: 16px;
    padding: 8px 24px;
    height: 32px!important;
  }
`

export const PrintPDFButton = styled.div`
  font-family: Inter;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.34px;
  color: ${Colors.galBlack47};

  cursor: pointer;

  display: flex;
  gap: 8px;

  svg {
    position: relative;
    top: -5px;
  }

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    justify-content: center;
  }

  &:hover {
    color: #151514;

    svg path {
      fill: #151514;
    }
  }
`;


export const OptionsWrapper = styled(FlexBox)`
  width: 100%;
  flex-flow: row;

  button {
    max-width: 185px;
    font-size: 15px;
    line-height: 20px;
    font-weight: 600;
    white-space: nowrap;

    @media(max-width: ${LayoutConst.screen.m}px) {
      height: 32px;
      min-height: 32px;
    }
  }

`;

export const OptionsEmptyWrapper = styled(FlexBox)`
  width: 100%;
  flex-flow: column;
  justify-content: center;
  place-items: center;

  button {
    max-width: 217px;
    font-size: 15px;
    line-height: 20px;
    font-weight: 600;
    height: 46px;
    white-space: nowrap;
  }

  button {
    @media(max-width: ${LayoutConst.screen.m}px) {
      height: 32px !important;
      min-height: 32px;
    }
  }
`;

export const EmptyTitle = styled.div`
  font-weight: 600;
  font-size: 30px;
  line-height: 33px;
  color: ${({ theme }) => theme.folders.emptyModal.titleColor};
  text-align: center;
`;

export const EmptySubtitle = styled.div`
  width: 100%;
  overflow: hideen;
  font-weight: 400;
  font-size: 17px;
  line-height: 22px;
  color: ${({ theme }) => theme.folders.emptyModal.titleColor};
`

export const OptionsIconWrapper = styled(FlexBox)`
  * {
    z-index: 0;
  }

  svg {
    cursor: pointer;

    &:hover {

      * {
          fill: ${({ theme }) => theme.folders.emptyModal.titleColor};
      }
    }

    @media(max-width: ${LayoutConst.screen.m}px) {
      &:hover {
        * {
            fill: ${({ theme }) => theme.folders.emptyModal.hoverColor};
        }
      }
    }
  }

`;import styled, {css} from "styled-components";
import {Colors, FlexBox, RectangularButtonFilled, RectangularButtonHollow} from "@brg/ui";
import { LayoutConst } from "core";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.folders.editModal.mainbg};
  width: 564px;
  padding: 24px 24px 24px 0px;
  row-gap: 24px;

  @media(max-width: ${LayoutConst.screen.m}px) {
    width: 348px;
    padding: 16px 0 0 0;
  }

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    width: 100%;
    row-gap: 16px;
  }

  .__react_component_tooltip {
    width: max-content !important;
  }

  input {
    background-color: ${({ theme }) => theme.folders.editModal.inputColor};
    color: ${({ theme }) => theme.folders.editModal.inputColor2};
    border-color: transparent;

    ::placeholder {
        color: #BFBFBF;
    }

    &:hover {
        ::placeholder {
            color: #BFBFBF;
        }
    }
  }

  span {
    color: #151514;
    font-size: 13px;
    line-height: 17px;
    margin-left: 10px;
  }

  input[type=checkbox] {
    background-color: transparent;
    border-color: #909090;
    width: 24px;
    height: 24px;
  }

  div[title=''] {
    width: 24px;
    height: 24px;
    border-color: #909090 !important;
    background-color: transparent;

    svg path {
      fill: ${({ theme }) => theme.folders.editModal.iconColor};
    }
  }

  .checkbox-text {
    font-size: 15px;
    line-height: 20px;
    color: #909090;
    position: absolute;
    left: 20px;
    bottom: 0;

    @media(max-width: ${LayoutConst.screen.md}px) {
      display: inline-flex;

      div {
        margin-left: 8px;
      }
    }
  }
`;

export const PinCheckboxWrapper = styled(FlexBox)<{ disable?: boolean }>`
  ${({ disable }) => disable && css`
    pointer-events: none;

    div[title=''] {
      opacity: 0.1;
    }

    input {
      opacity: 0.1;
    }
  `};
`;

export const Subtitle = styled.div`
    color: ${({ theme }) => theme.folders.editModal.subtitleColor};
    font-size: 15px;
    line-height: 20px;
    font-weight: 400;
`;

export const CloseModalIconWrapper = styled.div`
    position: absolute;
    right: 0;

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    right: 10px;
  }

  &:hover {
    svg path {
      fill: #151514;
    }
  }
`

export const Title = styled.div`
  color: ${({ theme }) => theme.folders.editModal.titleColor};
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 17px
  line-height: 22px;
  letter-spacing: -0.02em;

`

export const SendButton = styled.div<{isDisabled?: boolean, hollow?: boolean, fill?: boolean, red?: boolean, fullWidth?: boolean }>`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: -0.02em;
  height: 40px;
  color: ${({ theme, fill }) => fill ? theme.folders.editModal.buttonColorFill : theme.folders.editModal.buttonColorHollow};
  column-gap: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 121px;
  padding: 10px 24px;
  max-width: 348px;
  text-align: center;
  white-space: nowrap;
  background-color: ${({ hollow }) => hollow ? 'transparent' : '#151514'};
  opacity: ${({isDisabled}) => isDisabled ? 0.5 : 1};
  cursor: ${({isDisabled}) => isDisabled ? 'auto' : 'pointer'};
  border-radius: 3px;

  ${({ hollow, theme, red }) => hollow && css`
    border: 1px solid ${red ? '#C64839' : '#B6B6B5'};
    color: ${red ? '#C64839' : theme.folders.editModal.buttonColorHollow};
  `};

  @media(max-width: ${LayoutConst.screen.m}px) {
    font-size: 15px;
    line-height: 20px;
    min-width: ${({ fullWidth }) => fullWidth ? '348px' : '166px' };
    text-align: center;
    justify-content: center;

    ${({ red }) => red && css`
      margin-bottom: 8px;
    `};
  }
  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    width: 100%;
    min-width: 100%;
    height: 32px !important;
  }

  &:hover {
    .send-word {
      color: #151514;
    }

    svg path {
      fill: #151514;
    }
  }
`

export const ShareModalUrlField = styled.div`
  display: flex;
  align-items: center;
  padding: 15px 16px 13px;
  background: #F2F2F2;
  border-radius: 3px;
  height: 44px;
  width: 341px;

  span {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    color: #909090;
    width: 90%;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`

export const ShareModalUrlButton = styled(RectangularButtonFilled)<{isGameDeziiign?: boolean}>`
  height: 44px !important;
  width: 151px !important;
  min-width: 151px !important;
  max-width: 151px !important;
  ${({isGameDeziiign}) => isGameDeziiign && css`
    color: ${Colors.geoWhite100};
    background: ${Colors.galBlack100};
  `}
  
  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    width: calc(100% - 20px) !important;
    min-width: calc(100% - 20px) !important;
    max-width: calc(100% - 20px) !important;
    height: 38px !important;
    margin: 0px 10px;
    
    span {
      margin-left: 8px;
    }
  }
  
  svg {
    path {
      fill: ${({theme}) => theme.navigationBar.btns.filled.text.main};
      stroke: ${({theme}) => theme.navigationBar.btns.filled.text.main};

      ${p => p.importantStyles ? css`
        fill: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.main};
        stroke: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.main};
    ` : null}

      &:hover {
        ${p => p.importantStyles ? css`
          fill: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.text};
          stroke: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.text};
    ` : null}
      }
      
      &:active {
        ${p => p.importantStyles ? css`
          fill: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.text};
          stroke: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.text};
    ` : null}
    }
    &:disabled {
        fill: ${({theme}) => theme.navigationBar.btns.filled.text.disabled};

        ${p => p.importantStyles ? css`
          fill: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.text};
          stroke: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.text};
    ` : null}
    }
    }
  }
`

export const SubmitModalShareButton = styled(RectangularButtonFilled)`
  min-width: unset!important;
  max-width: unset!important;
  width: auto!important;
  padding: 12px 48px;
  font-weight: 600;
  font-size: 17px;
  line-height: 22px;
  height: 46px!important;
  letter-spacing: -0.02em;
  
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: 13px;
    line-height: 16px;
    padding: 8px 24px;
    height: 32px!important;
  }
`

export const PrintPDFButton = styled.div`
  font-family: Inter;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.34px;
  color: ${Colors.galBlack47};

  cursor: pointer;

  display: flex;
  gap: 8px;

  svg {
    position: relative;
    top: -5px;
  }

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    justify-content: center;
  }

  &:hover {
    color: #151514;

    svg path {
      fill: #151514;
    }
  }
`;


export const OptionsWrapper = styled(FlexBox)`
  width: 100%;
  flex-flow: row;

  button {
    max-width: 185px;
    font-size: 15px;
    line-height: 20px;
    font-weight: 600;
    white-space: nowrap;

    @media(max-width: ${LayoutConst.screen.m}px) {
      height: 32px;
      min-height: 32px;
    }
  }

`;

export const OptionsEmptyWrapper = styled(FlexBox)`
  width: 100%;
  flex-flow: column;
  justify-content: center;
  place-items: center;

  button {
    max-width: 217px;
    font-size: 15px;
    line-height: 20px;
    font-weight: 600;
    height: 46px;
    white-space: nowrap;
  }

  button {
    @media(max-width: ${LayoutConst.screen.m}px) {
      height: 32px !important;
      min-height: 32px;
    }
  }
`;

export const EmptyTitle = styled.div`
  font-weight: 600;
  font-size: 30px;
  line-height: 33px;
  color: ${({ theme }) => theme.folders.emptyModal.titleColor};
  text-align: center;
`;

export const EmptySubtitle = styled.div`
  width: 100%;
  overflow: hideen;
  font-weight: 400;
  font-size: 17px;
  line-height: 22px;
  color: ${({ theme }) => theme.folders.emptyModal.titleColor};
`

export const OptionsIconWrapper = styled(FlexBox)`
  * {
    z-index: 0;
  }

  svg {
    cursor: pointer;

    &:hover {

      * {
          fill: ${({ theme }) => theme.folders.emptyModal.titleColor};
      }
    }

    @media(max-width: ${LayoutConst.screen.m}px) {
      &:hover {
        * {
            fill: ${({ theme }) => theme.folders.emptyModal.hoverColor};
        }
      }
    }
  }

`;